import React from 'react'

import styles from './styles.module.scss'

const LoaderComponent = () => (
  <div className={ styles.spinner }>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
)

export default LoaderComponent
